module.exports = Object.freeze({
    app: require('./app'),
    company: require('./company'),
    services: require('./services')
});
